export const ScopeStatusColor = {
  DRAFT: 'text-slate-600',
  SUBMITTED: 'text-orange-500',
  IN_REVIEW: 'text-yellow-400',
  AGENCY_APPROVED: 'text-green-500',
  CLIENT_APPROVED: 'text-green-500',
  SCOPING: 'text-green-500',
  TRAFFICKED: 'text-blue-500',
  CLOSED: 'text-red-500',
  CONFIG_DRAFT: 'text-critical-700',
}
